import { Component, Vue } from 'vue-property-decorator';
import { Validations } from 'vuelidate-property-decorators';
import { FormFieldModel, FieldsModel } from '../../models/LoginModels';
import { EFieldNames } from '../../models/Enums/EFieldNames';
import SimpleLayout from './SimpleLayout.vue';

@Component({
  components: {
    SimpleLayout,
  },
})
export default class SimpleLayoutAbstract extends Vue {
  @Validations()
  validations = {};

  public fields: FieldsModel = {};

  public model = {};

  get isFormInvalid(): boolean {
    return this.$v.model.$dirty && this.$v.model.$invalid;
  }

  get errors(): {[errorName: string]: string} {
    return Object.fromEntries(
      Object.entries(this.fields).map(
        ([field, { errors }]: [string, FormFieldModel]) => ([
          field,
          Object.entries(errors).reduce((err, [key, text]: [string, string]) => {
            if (err) return err;

            const vField = this.$v.model[field];
            if (vField && !vField[key] && vField.$dirty) return text;

            return '';
          },
          ''),
        ]),
      ),
    );
  }

  checkValidation(fields: EFieldNames[]) {
    return fields.every((field: string) => {
      const vField = this.$v.model[field];
      return vField && vField.$dirty && !vField.$invalid;
    });
  }
}
